import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'sm' | 'md' | 'lg';
}

const paddingClasses = {
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
} as const;

export function Card({ children, className = '', hover = true, padding = 'md' }: CardProps) {
  return (
    <div className={`glass ${hover ? 'glass-hover' : ''} ${paddingClasses[padding]} rounded-xl ${className}`}>
      {children}
    </div>
  );
}
